import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Renderer2,
  Inject,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import MetisMenu from 'metismenujs';
import { permissions } from 'src/app/permissions';
import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { Router, NavigationEnd } from '@angular/router';
import { DataService } from 'src/app/services/data/data.service';
import { UpdateService } from 'src/app/services/update/update.service';
import { KeyboardShortcutsService } from 'src/app/services/keyboard-shortcuts/keyboard-shortcuts.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, AfterViewInit {
  @ViewChild('sidebarToggler') sidebarToggler: ElementRef;
  menuItems: MenuItem[] = [];
  @ViewChild('sidebarMenu') sidebarMenu: ElementRef;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    router: Router,
    private dataService: DataService,
    private update: UpdateService,
    private shortcutService: KeyboardShortcutsService
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        /**
         * Activating the current active item dropdown
         */
        this._activateMenuDropdown();
        /**
         * closing the sidebar
         */
        if (window.matchMedia('(max-width: 991px)').matches) {
          this.document.body.classList.remove('sidebar-open');
        }
      }
    });
  }
  ngOnInit(): void {
    this.toggleSidenav();
    this.menuItems = MENU;
    //console.log(this.menuItems);
    /**
     * Sidebar-folded on desktop (min-width:992px and max-width: 1199px)
     */
    const desktopMedium = window.matchMedia(
      '(min-width:992px) and (max-width: 1199px)'
    );
    desktopMedium.addEventListener('change', () => {
      this.iconSidebar;
    });
    this.iconSidebar(desktopMedium);
  }
  ngAfterViewInit() {
    // activate menu item
    new MetisMenu(this.sidebarMenu.nativeElement);
    this._activateMenuDropdown();
  }
  /**
   * Toggle sidebar on hamburger button click
   */
  toggleSidebar(e: Event) {
    this.sidebarToggler.nativeElement.classList.toggle('active');
    this.sidebarToggler.nativeElement.classList.toggle('not-active');
    if (window.matchMedia('(min-width: 992px)').matches) {
      e.preventDefault();
      this.document.body.classList.toggle('sidebar-folded');
    } else if (window.matchMedia('(max-width: 991px)').matches) {
      e.preventDefault();
      this.document.body.classList.toggle('sidebar-open');
    }
  }
  /**
   * Toggle settings-sidebar
   */
  toggleSettingsSidebar(e: Event) {
    e.preventDefault();
    this.document.body.classList.toggle('settings-open');
  }
  /**
   * Open sidebar when hover (in folded folded state)
   */
  operSidebarFolded() {
    if (this.document.body.classList.contains('sidebar-folded')) {
      this.document.body.classList.add('open-sidebar-folded');
    }
  }
  /**
   * Fold sidebar after mouse leave (in folded state)
   */
  closeSidebarFolded() {
    if (this.document.body.classList.contains('sidebar-folded')) {
      this.document.body.classList.remove('open-sidebar-folded');
    }
  }
  /**
   * Sidebar-folded on desktop (min-width:992px and max-width: 1199px)
   */
  iconSidebar(mq: MediaQueryList) {
    if (mq.matches) {
      this.document.body.classList.add('sidebar-folded');
    } else {
      this.document.body.classList.remove('sidebar-folded');
    }
  }
  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }
  /**
   * Reset the menus then hilight current active menu item
   */
  _activateMenuDropdown() {
    this.resetMenuItems();
    this.activateMenuItems();
  }
  /**
   * Resets the menus
   */
  resetMenuItems() {
    const links = document.getElementsByClassName('nav-link-ref');
    for (let i = 0; i < links.length; i++) {
      const menuItemEl = links[i];
      menuItemEl.classList.remove('mm-active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.remove('mm-active');
        const parent2El = parentEl.parentElement;
        if (parent2El) {
          parent2El.classList.remove('mm-show');
        }
        const parent3El = parent2El?.parentElement;
        if (parent3El) {
          parent3El.classList.remove('mm-active');
          if (parent3El.classList.contains('side-nav-item')) {
            const firstAnchor = parent3El.querySelector('.side-nav-link-a-ref');
            if (firstAnchor) {
              firstAnchor.classList.remove('mm-active');
            }
          }
          const parent4El = parent3El.parentElement;
          if (parent4El) {
            parent4El.classList.remove('mm-show');
            const parent5El = parent4El.parentElement;
            if (parent5El) {
              parent5El.classList.remove('mm-active');
            }
          }
        }
      }
    }
  }
  /**
   * Toggles the menu items
   */
  activateMenuItems() {
    const links: any = document.getElementsByClassName('nav-link-ref');
    let menuItemEl = null;
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      if (window.location.pathname === links[i]['pathname']) {
        menuItemEl = links[i];
        break;
      }
    }
    if (menuItemEl) {
      menuItemEl.classList.add('mm-active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement;
        if (parent2El) {
          parent2El.classList.add('mm-show');
        }
        const parent3El = parent2El.parentElement;
        if (parent3El) {
          parent3El.classList.add('mm-active');
          if (parent3El.classList.contains('side-nav-item')) {
            const firstAnchor = parent3El.querySelector('.side-nav-link-a-ref');
            if (firstAnchor) {
              firstAnchor.classList.add('mm-active');
            }
          }
          const parent4El = parent3El.parentElement;
          if (parent4El) {
            parent4El.classList.add('mm-show');
            const parent5El = parent4El.parentElement;
            if (parent5El) {
              parent5El.classList.add('mm-active');
            }
          }
        }
      }
    }
  }
  toggleSidenav() {
    if (this.dataService.userDetails.is_admin == 1) {
      this.enableAllMenuItems(MENU);
      // hide smart cart in business level
      if (this.dataService.selectedOutlet == 0) {
        const smartCartIndex = MENU.findIndex(
          (ele) => ele.link === '/smart-cart'
        );
        if (smartCartIndex !== -1) {
          MENU[smartCartIndex].disabled = true;
        }
      }
      let shortcutMenuItems = MENU;
      this.shortcutService.shortcutsMenu = shortcutMenuItems;
    } else if (this.dataService.selectedOutlet != 0) {
      let permissionForOutlet = this.dataService.userPermissions.filter(
        (ele) => ele.outlet_id == this.dataService.selectedOutlet
      );
      let permissionUrls: any[] = [];
      for (const item of permissionForOutlet) {
        item.urls = []; // Initialize 'item.urls' as an empty array for each 'item'
        permissions.forEach((ele) => {
          if (
            ele.feature_id == item.feature_id &&
            (item.create ||
              item.delete ||
              item.update ||
              item.view ||
              item.auto_approve)
          ) {
            item.urls.push(ele.url);
            // Push matching URLs to 'item.urls' array
          }
        });
        permissionUrls.push(item); // Push all URLs from 'item.urls' to 'permissionUrls' array
      }
      // console.log(permissionForOutlet);
      // console.log(permissionUrls);
      for (const item of permissionForOutlet) {
        item.urls.forEach((ele: any) => {
          for (const element of MENU) {
            if (element.label?.toLowerCase() === 'purchase order') debugger;
            // Check if the 'element' has 'subItems'
            if (element.subItems) {
              element.subItems.forEach((submenu: any) => {
                // Iterate through each 'submenu' in the 'subItems' array of the 'element'
                if (submenu.link == ele) {
                  // Check if the 'link' of the 'submenu' matches the current 'ele' URL
                  if (submenu.link.includes('create') && item.create == 0) {
                    // Check if the 'submenu.link' contains 'create' and 'item.create' is 0
                    submenu.disabled = true;
                  } else {
                    submenu.disabled = false;
                  }
                }
              });
              let check = 0;
              element.subItems.forEach((subItem: any) => {
                if (subItem.disabled == false) {
                  check++;
                }
              });
              if (check > 0) {
                // If all 'subItems' in 'element' have been processed and none match the 'ele' URL
                element.disabled = false;
              } else if (check == 0) {
                element.disabled = true;
              }
            } else {
              if (element.link == ele) {
                // If the 'element' does not have 'subItems'
                element.disabled = false;
              }
            }
          }
        });
      }
      //for enabling the all option in side nav
      let flagForContact = 0;
      let flagForProduct = 0;
      for (
        let index = 0;
        index < this.dataService.userPermissions.length;
        index++
      ) {
        if (
          this.dataService.userPermissions[index].feature_id == 17 ||
          this.dataService.userPermissions[index].feature_id == 18 ||
          this.dataService.userPermissions[index].feature_id == 19
        ) {
          if (this.dataService.userPermissions[index].view == 1) {
            flagForContact++;
          }
        }
        if (
          this.dataService.userPermissions[index].feature_id == 20 ||
          this.dataService.userPermissions[index].feature_id == 21 ||
          this.dataService.userPermissions[index].feature_id == 22
        ) {
          if (this.dataService.userPermissions[index].view == 1) {
            flagForProduct++;
          }
        }
      }
      if (flagForContact == 3) {
        let enableAll = MENU.find((ele: any) => ele.label === 'Contacts');
        if (enableAll) {
          enableAll.subItems[0].disabled = false;
        }
      } else {
        let enableAll = MENU.find((ele: any) => ele.label === 'Contacts');
        if (enableAll) {
          enableAll.subItems[0].disabled = true;
        }
      }
      if (flagForProduct == 3) {
        let enableAll = MENU.find((ele: any) => ele.label === 'Products');
        if (enableAll) {
          enableAll.subItems[0].disabled = false;
        }
      } else {
        let enableAll = MENU.find((ele: any) => ele.label === 'Products');
        if (enableAll) {
          enableAll.subItems[0].disabled = true;
        }
      }
      let shortcutMenuItems = MENU;
      this.shortcutService.shortcutsMenu = shortcutMenuItems;

      console.log(MENU);
    } else {
      this.enableAllMenuItems(MENU);
      let shortcutMenuItems = MENU;
      this.shortcutService.shortcutsMenu = shortcutMenuItems;
    }
    // console.log(MENU);
  }
  enableAllMenuItems(menuItems: MenuItem[]) {
    for (const item of menuItems) {
      item.disabled = false;
      if (item.subItems) {
        this.enableAllMenuItems(item.subItems);
      }
    }
    //console.log(MENU);
  }
  updateApplication() {
    this.update.hardRefresh();
  }
}
